import { render, staticRenderFns } from "./FTPSPdRes.vue?vue&type=template&id=456a3038&scoped=true&"
import script from "./FTPSPdRes.vue?vue&type=script&lang=js&"
export * from "./FTPSPdRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456a3038",
  null
  
)

export default component.exports